/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { fulfillmentLabels } from '../../constants/fulfillmentConstants';
import styles from './styles.module.scss';
import type { FulfillmentOption } from '@/types/reduxStore/skuDetails';
import { useLabels } from '@/hooks/useLabels';
import { OrderWithinHrsMinArrivesMessage } from './FulfillmentCutoff';
import { useLegacyRouter } from '@/hooks/useLegacyRouter';
import { routePaths } from '@/constants/routePaths';

const labels = {
  label_sdd_shipping_price: 'label_fulfilment_options_sdd_shipping_price',
  label_today: 'label_fulfilment_options_today',
  label_sdd_promos: 'label_shipping_infoPopper_sdd_promos',
  in_stock_label: 'label_cart_lineItem_InStock',
};

export default function SameDayOption({
  option,
}: {
  option: FulfillmentOption;
  skuId: string | undefined;
  productName: string;
}) {
  const router = useLegacyRouter();
  const labelMap = useLabels(labels);
  const isCartPage = router.asPath.includes(routePaths.cart);

  return (
    <>
      <div className={styles.NextDaylistItemContainer} data-testid="same-day-delivery">
        <div>
          <div data-testid="same-day" className={styles.inStockLabel}>
            <div className={styles.inStockLabelContainer}>
              <div className={styles.tickmarkContainer}>
                <img src="/images/green-tickmark.svg" alt="" />{' '}
              </div>
              <span>
                <span className={styles.successBoldedMessage}>{labelMap.in_stock_label}</span>
                <span> | </span>
                <OrderWithinHrsMinArrivesMessage
                  estDeliveryDateString={option.estimatedDeliveryDate}
                  cutOffDateString={option.fullfillmentCutOffDate}
                  orderByLabel={fulfillmentLabels.label_shipping_cutoff_ampm_head}
                  arrivesByLabel={fulfillmentLabels.label_shipping_cutoff_ampm_tail}
                  displayAmPmFormat={true}
                  isCartPage={isCartPage}
                  isNdd={false}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
